<template>
  <el-dialog
    :title="title"
    :visible="true"
    width="700px"
    :close-on-click-modal="false"
    :before-close="handleClose"
  >
    <el-form
      ref="taskForm"
      v-loading="loading"
      :model="task"
      :rules="rules"
      label-position="top"
      autocomplete="off"
      style="margin-bottom: 30px;"
      @submit.native.prevent="store"
    >
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            prop="title"
            label="Megnevezés"
          >
            <el-input
              v-model="task.title"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            prop="assignType"
            label="Hozzárendelés típusa"
          >
            <el-select
              v-model="assignType"
              style="width: 100%;"
            >
              <el-option
                label="Kiválasztott üzletek"
                value="shop"
              />
              <el-option
                label="Kiválasztott üzletláncok"
                value="chain"
              />
              <el-option
                label="Kiválasztott üzletkategóriák"
                value="category"
              />
              <el-option
                label="Kiválasztott területek"
                value="location"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item
        v-if="type === 'add' && assignType === 'shop'"
        prop="shop_id"
        label="Üzlet(ek)"
      >
        <el-select
          v-model="task.shops"
          multiple
          filterable
          remote
          reserve-keyword
          :remote-method="fetchShops"
          placeholder="Írd be az üzlet nevét a kereséshez..."
          :loading="shopLoading"
          style="width: 100%;"
          value-key="id"
        >
          <el-option
            v-for="shop in shops"
            :key="shop.id"
            :value="shop"
            :label="`#${shop.id} ${shop.name}`"
          >
            <strong>#{{ shop.id }}</strong> {{ shop.name }}
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        v-if="type === 'add' && assignType === 'location'"
        prop="location_id"
        label="Terület(ek)"
      >
        <el-select
          v-model="task.locations"
          multiple
          filterable
          placeholder="Írd be az terület nevét a kereséshez..."
          style="width: 100%;"
          value-key="id"
        >
          <el-option
            v-for="location in locations"
            :key="location.id"
            :label="location.value"
            :value="location"
          />
        </el-select>
      </el-form-item>
      <el-form-item
        v-if="type === 'add' && assignType === 'category'"
        prop="category_id"
        label="Üzletkategóri(ák)"
      >
        <el-select
          v-model="task.categories"
          multiple
          filterable
          placeholder="Írd be az üzletkategória nevét a kereséshez..."
          style="width: 100%;"
          value-key="id"
        >
          <el-option
            v-for="category in categories"
            :key="category.id"
            :label="category.name"
            :value="category"
          />
        </el-select>
      </el-form-item>
      <el-form-item
        v-if="type === 'add' && assignType === 'chain'"
        prop="chain_id"
        label="Üzletlánc(ok)"
      >
        <el-select
          v-model="task.chains"
          multiple
          filterable
          placeholder="Írd be az üzletlánc nevét a kereséshez..."
          style="width: 100%;"
          value-key="id"
        >
          <el-option
            v-for="chain in chains"
            :key="chain.id"
            :label="chain.name"
            :value="chain"
          />
        </el-select>
      </el-form-item>
      <el-alert
        v-if="shopsCount"
        :title="`Összesen ${shopsCount} üzlethez lesz hozzárendelve ez az időszaki munka`"
        type="info"
        show-icon
        :closable="false"
        style="margin-bottom: 20px;"
      />
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item
            prop="valid_from"
            label="Érvényesség kezdete"
          >
            <el-date-picker
              v-model="task.valid_from"
              type="date"
              format="yyyy. MM. dd."
              value-format="yyyy-MM-dd"
              :picker-options="{ firstDayOfWeek: 1 }"
              style="width: 100%;"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            prop="valid_to"
            label="Érvényesség vége"
          >
            <el-date-picker
              v-model="task.valid_to"
              type="date"
              format="yyyy. MM. dd."
              value-format="yyyy-MM-dd"
              :picker-options="{ firstDayOfWeek: 1 }"
              style="width: 100%;"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <hr class="dialog-separator">
    <el-button
      style="margin-bottom: 20px;"
      type="success"
      icon="el-icon-plus"
      @click="addTask()"
    >
      Új feladat
    </el-button>
    <div
      v-for="(taskItem, index) in task.task_items"
      :key="`${index}-taskitem`"
    >
      <el-card
        :key="`${index}-taskcard`"
        style="margin-bottom: 30px;"
      >
        <div
          slot="header"
          style="font-weight: 600;"
        >
          #{{ index + 1 }} feladat
          <el-button
            :key="`${index}-taskitem-button`"
            style="float: right; margin-top: -6px;"
            type="danger"
            size="mini"
            icon="el-icon-remove"
            @click="removeTask(index)"
          >
            Törlés
          </el-button>
        </div>
        <task-item
          :key="`${index}-taskitem-component`"
          :item="taskItem"
          ref="taskItems"
        />
      </el-card>
    </div>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <div>
        <el-button @click="handleClose">
          Mégse
        </el-button>
        <el-button
          type="primary"
          :loading="buttonLoading"
          @click="store"
        >
          {{ buttonText }}
        </el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import TaskItem from './Task';

export default {
  components: { TaskItem },
  props: ['type', 'taskId'],
  data() {
    return {
      assignType: 'shop', // shop, category, location, chain
      loading: false,
      buttonLoading: false,
      shopLoading: false,
      taskCount: 1,
      shops: [],
      task: {
        shops: [],
        locations: [],
        categories: [],
        chains: [],
        status: 'todo',
        task_items: [
          {
            type: 'measure',
          }
        ],
      },
      rules: {
        title: [
          {
            required: true,
            message: 'Cím megadása kötelező',
            trigger: 'change'
          }
        ],
        deadline: [
          {
            required: true,
            message: 'Határidő megadása kötelező',
            trigger: 'change'
          }
        ],
        responsible_user_id: [
          {
            required: true,
            message: 'Felelős megadása kötelező',
            trigger: 'change'
          }
        ]
      },
    };
  },
  computed: {
    shopsCount() {
      let count = 0;
      if (this.assignType === 'shop') {
        return this.task.shops.length;
      } else if (this.assignType === 'location') {
        this.task.locations.map(l => count += l.shops_count);
      } else if (this.assignType === 'category') {
        this.task.categories.map(l => count += l.shops_count);
      } else if (this.assignType === 'chain') {
        this.task.chains.map(l => count += l.shops_count);
      }
      return count;
    },
    categories() {
      return this.$store.getters['shopCategory/shopCategories'];
    },
    chains() {
      return this.$store.getters['shopChain/shopChains'];
    },
    locations() {
      return this.$store.getters['location/locations'];
    },
    users() {
      return this.$store.getters['user/users'];
    },
    title() {
      if (this.type === 'add') {
        return 'Új időszaki munka';
      } else if (this.type === 'update') {
        return 'Időszaki munka módosítása';
      } else {
        return '';
      }
    },
    buttonText() {
      if (this.type === 'add') {
        return 'Hozzáadása';
      } else if (this.type === 'update') {
        return 'Módosítás';
      } else {
        return '';
      }
    },
  },
  async mounted() {
    this.loading = true;
    const requiredFetches = [];
    if (!this.users.length) {
      requiredFetches.push(this.$store.dispatch('user/fetchAll'));
    }
    if (!this.chains.length) {
      requiredFetches.push(this.$store.dispatch('shopChain/fetchAll'));
    }
    if (!this.categories.length) {
      requiredFetches.push(this.$store.dispatch('shopCategory/fetchAll'));
    }
    if (!this.locations.length) {
      requiredFetches.push(this.$store.dispatch('location/fetchAll'));
    }
    await Promise.all(requiredFetches);
    if (this.taskId) {
      this.task = await this.$store.dispatch('task/fetch', this.taskId);
    }
    this.loading = false;
  },
  methods: {
    handleClose() {
      this.$confirm('Biztosan elveted a módosításokat?', {
        confirmButtonText: 'Igen',
        type: 'warning',
      })
        .then(() => {
          this.$router.replace('/representative-processes/tasks');
        })
        .catch(() => {
        });
    },
    async store() {
      this.$refs['taskForm'].validate(async valid => {
        if (valid) {
          const questionnaires = [];
          const measures = [];
          const photos = [];
          this.$refs['taskItems'].forEach(task => {
            if (task.$refs.questionnaire && task.$refs.questionnaire.questionnaire) {
              questionnaires.push({
                title: task.task.title,
                ...task.$refs.questionnaire.questionnaire
              });
            }
            if (task.task.type === 'measure') {
              measures.push({
                title: task.task.title,
                products: task.task.products,
              });
            }
            if (task.task.type === 'photo') {
              photos.push({
                title: task.task.title,
              });
            }
          });
          this.buttonLoading = true;
          try {
            await this.$store.dispatch('task/create', {
              title: this.task.title,
              valid_from: this.task.valid_from,
              valid_to: this.task.valid_to,
              shops: this.assignType === 'shop' ? this.task.shops : [],
              categories: this.assignType === 'category' ? this.task.categories : [],
              chains: this.assignType === 'chain' ? this.task.chains : [],
              locations: this.assignType === 'location' ? this.task.locations : [],
              questionnaires,
              measures,
              photos,
            });
            this.$store.dispatch('job/fetchAll');
            this.$router.replace('/representative-processes/tasks');
          } catch (e) {
          }

          this.buttonLoading = false;
        }
      });
    },
    removeTask(index) {
      this.task.task_items.splice(index, 1);
    },
    addTask() {
      this.task.task_items.push({
        type: 'measure',
      });
    },
    async fetchShops(query) {
      if (query !== '') {
        this.shopLoading = true;
        this.shops = await axios.get('/api/shops/name/' + query);
        this.shopLoading = false;
      }
    },
  },
};
</script>
